// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jw-1";
export var messageSideRight = "_jw-2";
export var orderLookupBubbleContainer = "_jw-0";
export var submitButton = "_jw-3";